import { Component } from '@angular/core';
import { AddUserForm } from '../../../../components/admin-dashboard-component/user-management/add-user-form/add-user-form';

@Component({
  selector: 'app-add-user',
  imports: [AddUserForm],
  templateUrl: './add-user.html',
  styleUrl: './add-user.scss',
})
export class AddUser {}
